<template>
  <div class="waiver-container">
    <FormLabel class="control-label fulllabel">
      Please read this media release and sign electronically below.
    </FormLabel>
    <div class="waiver-text">
      <p>
        From time to time, {{ organization }}, and its affiliates, employees and agents
        (together, the “{{ organization }}”) take photographs and videos of individuals,
        including minors, who attend {{ organization }} events, programs, and other
        offerings. The {{ organization }} engages in these activities for purposes
        relating to the advancement of the religious, spiritual, charitable, and
        educational goals and objectives of the {{ organization }}, including but not
        limited to the sharing of photos/videos in newsletters, on our blogs, and on our
        website and social media pages for the purpose of keeping our members and others
        informed of the {{ organization }}’s events and other activities. Please complete
        this form to give us permission to take photos/videos of you and/or your children
        when you participate in {{ organization }} events and to use those photos/videos
        in our printed and online publicity:
      </p>
      <ol>
        <li>
          I hereby authorize the {{ organization }} to take photographs and/or video of me
          (or my children) when I (or my children) participate at
          {{ organization }} events. I grant the {{ organization }} full rights to use and
          share the images resulting from the photographs and/or videos and any
          reproductions thereof (the “Recording”), in whole or in part, along with my (or
          my children’s) name, biographical information and quotations for any purpose
          including fundraising, publicity, advertising, or on social media, all without
          further obligation or compensation.&nbsp; I hereby waive any right of review or
          approval regarding the Recording and the {{ organization }} shall have the right
          to edit or delete the Recording in its sole discretion. I understand that all
          rights in and to the Recording shall be the {{ organization }}’s sole and
          absolute property. I understand that if I access the {{ organization }}’s
          services through a third party platform, product, service, or application (a
          “Third Party Service”), content and related information generated while
          accessing {{ organization }}’s services in this manner may be monitored,
          captured, and or recorded by the third parties that provide such Third Party
          Services. I consent to the use and sharing of personal information by any such
          third party as described in the privacy policy available through the Third Party
          Service. I release and forever discharge the {{ organization }} from all causes
          of action, suits, or liability of any kind arising from or in connection with
          the use or publication of any Recording of me or my children made in connection
          with my participation in {{ organization }} events. I waive any right of privacy
          associated with the Recording and I waive any right to compensation related to
          the use of the Recording.
        </li>
        <li>
          I HAVE READ THIS AGREEMENT AND AM FULLY AWARE OF ITS CONTENTS, INCLUDING THE
          RELEASE THAT I HAVE AGREED TO HEREIN.
        </li>
        <li>
          I warrant that I am at least eighteen years of age (or, if not, that my parent
          or legal guardian has agreed to the foregoing and signed below) and that I have
          the full and unrestricted authority to enter into a contract for myself (or, if
          not, that my parent or legal guardian has agreed to the foregoing and signed
          below).
        </li>
        <li>
          If any provision of this agreement is held to be unenforceable, the remainder of
          it shall continue to be in full force and effect.
        </li>
        <li>
          This waiver shall remain in effect until such time as I advise the
          {{ organization }} otherwise in writing.
        </li>
      </ol>
    </div>
    <div class="waiver-fields">
      <div style="width: 100%">
        <FormLabel class="control-label"> Check one of the following boxes </FormLabel>

        <div class="parents__release">
          <FormLabel for="above18" class="parents__label">
            <input
              type="radio"
              id="above18"
              name="parents_release_age"
              value="above18"
              :model="parentsAgeRelase"
              @click="parentsAgeRelase = 'above18'"
              :checked="parentsAgeRelase == 'above18'"
            /><span>I am 18 years of age and I give consent</span>
          </FormLabel>
          <FormLabel for="below18" class="parents__label">
            <input
              type="radio"
              id="below18"
              name="parents_release_age"
              value="below18"
              :model="parentsAgeRelase"
              @click="parentsAgeRelase = 'below18'"
              :checked="parentsAgeRelase == 'below18'"
            /><span> I am under 18 years of age</span>
          </FormLabel>
          <ErrorLabel
            field="custom.parentsAgeRelase"
            customError="Please select a gender"
          />
        </div>
      </div>

      <div class="waiver-fields" v-if="getValue('custom.parentsAgeRelase') == 'below18'">
        <label
          style="
            background-color: rgb(247, 247, 247);
            font-style: italic;
            padding: 5px 10px;
            font-size: 14px;
            display: block;
            line-height: 21px;
            margin-bottom: 10px;
          "
          class="showIfMinor"
          >Complete the top part of the form AND have a parent or guardian complete the
          bottom part of the form.</label
        >

        <FormLabel class="control-label fulllabel">
          Please have a parent/guardian read this release and have them electronically
          sign below
        </FormLabel>
        <div class="waiver-text">
          <p>
            As the parent or guardian of the minor named above, I hereby expressly approve
            and consent to this Media Release and Agreement and agree to all of the
            foregoing terms on behalf of myself and the minor, for whom I have every right
            to contract for in the above regard. For good and valuable consideration, I
            hereby guarantee that the minor shall not at any time disaffirm the terms and
            conditions of this Media Release by reason of the minor’s minority or
            otherwise. The consideration provided for and referenced in the Media Release
            shall be deemed to be the consideration in full for all rights granted to the
            OU Producers and for all obligations undertaken pursuant to the Media Release
            and pursuant to this parental consent, not only by the minor but also by me.
          </p>
        </div>
      </div>

      <div class="waiver-fields">
        <br />
        <FormRow inline>
          <FormCol field="custom.signature" width="full" :showLabel="false">
            <label class="control-label"
              ><span v-if="getValue('custom.parentsAgeRelase') == 'below18'"
                >Parent/Guardian </span
              >Signature
            </label>
            <FormInput type="text" class="width-full" field="custom.signature" />
          </FormCol>
        </FormRow>
        <br />
        <ErrorLabel field="custom.signature" customError="Please sign" />
      </div>

      <!-- <FormRow>
        <label
          ><input
            type="checkbox"
            @value="getValue('custom.mediaRelease')"
            @change="setValue('custom.mediaRelease', $event.target.checked)"
          />
          I accept the terms of the media release</label
        >
      </FormRow>
      <ErrorLabel
        field="custom.mediaRelease"
        customError="Please accept the media release"
      /> -->
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    organization: {
      type: String,
      default: "Orthodox Union",
    },
  },
  setup() {
    const { getValue, setValue } = usePaymentForm();

    const parentsAgeRelase = ref("above18");

    onMounted(() => {
      setValue("custom.parentsAgeRelase", "above18");
    });

    watch(parentsAgeRelase, () => {
      if (parentsAgeRelase.value) {
        setValue("custom.parentsAgeRelase", parentsAgeRelase.value);
      }
    });

    return {
      getValue,
      parentsAgeRelase,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
.waiver-text {
  max-height: 200px;
  overflow: auto;
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px 20px 20px;
  margin-bottom: 20px;
}
p,
ul,
h2 {
  margin-bottom: 20px;
  line-height: 1.4;
  font-size: 13px;
}
ol {
  margin-bottom: 0px;
  line-height: 1.4;
  font-size: 13px;
}
li {
  margin-bottom: 5px;
}
label {
  font-size: 14px;
  min-width: 150px;
  color: #222;
}

.parents__label {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
}
::v-deep .error-label {
  position: relative;
}
.parents__release {
  padding-top: 10px;
  padding-bottom: 20px;
}
.control-label.fulllabel {
  margin-bottom: 5px;
}
</style>
